import type { Question } from "../api/dto/Question";
import { localizeText } from "./localizeText";

const stripTags = (html: string): string =>
  new DOMParser().parseFromString(html, "text/html").body.textContent?.trim() ?? "";

/**
 * Short plain-text label for a question, for places where only one line fits (e.g. dashboards).
 * Not every question has a short description, so this falls back to the header and then the
 * description, which may contain formatting tags.
 */
export const questionLabel = (question: Question | undefined): string => {
  if (!question) {
    return "Onbekende vraag";
  }
  return (
    question.shortDescription ||
    stripTags(localizeText(question.header)) ||
    stripTags(localizeText(question.description)) ||
    `Vraag ${question.number}`
  );
};
